export const mapQueryTypeToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const queryTypeColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "slug", label: "Slug", align: "center" },
];
